module.exports = __webpack_public_path__ + "static/img/3.21502a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/eng/3.png
// module id = NwqR
// module chunks = 0